import React from "react";
import { TableCell, TableHead, TableRow } from "@mui/material";
import { SortableTableHeader } from "@components";
import { TableConfig } from "../types.ts";

type Props<Data> = {
  settings: TableConfig<Data>;
  sortField?: string;
  sortDirection?: TableSortDirection;
  onSort: (sortByName: string) => void;
  hasExpandableRows: boolean;
};

export function AutoTableHead<Data>({
  settings,
  sortField,
  sortDirection,
  onSort,
  hasExpandableRows,
}: Props<Data>) {
  return (
    <TableHead>
      <TableRow>
        {hasExpandableRows && settings.arrowPosition !== "last" && (
          <TableCell sx={{ width: 32, p: 0 }} />
        )}
        {settings.columns.map((col, idx) =>
          col.hidden ? null : (
            <SortableTableHeader
              key={col.id ?? idx}
              isSortable={col.sortable}
              sortField={sortField}
              sortDirection={sortDirection}
              sortByName={col.sortKey ?? col.id}
              text={col.title}
              onClick={settings.onSort ?? onSort}
              align={col.align}
            />
          )
        )}
        {hasExpandableRows && settings.arrowPosition === "last" && (
          <TableCell sx={{ width: 32, p: 0 }} />
        )}
      </TableRow>
    </TableHead>
  );
}
